import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

interface StreamCardProps {
  streams: {
    id: string;
    icon: any;
    stream_name: string;
  };
  numberOfColleges: number;
  linkUrl?: string;
}

const StreamCard: React.FC<StreamCardProps> = ({ streams, numberOfColleges, linkUrl = 'colleges-in-india' }) => {
  // Generate the URL dynamically
  const cardUrl =
    numberOfColleges > 0
      ? `/${streams?.stream_name?.replace(/\s+/g, '-').toLowerCase()}-${linkUrl?.replace(/\s+/g, '-').toLowerCase()}`
      : undefined;

  return (
    <Link href={cardUrl ?? '#'} passHref>
      <div
        className="mx-0.5 mb-0.5 flex h-16 max-h-16 min-h-16 w-full items-center gap-x-3 rounded-lg border p-2 text-start shadow-md transition-shadow duration-200 hover:shadow-lg focus:ring-2 focus:ring-blue-500 lg:max-w-48 2xl:max-w-[14.5rem]"
        aria-disabled={!cardUrl}
      >
        <Image
          src={streams?.icon?.url}
          alt={streams?.stream_name || 'default stream'}
          width={44}
          height={44}
          className="w-auto object-fill object-center"
        />
        <div className="flex flex-col py-1">
          <p className="line-clamp-2 font-sans text-xs font-semibold leading-4 tracking-tight">
            {streams?.stream_name}
          </p>
          <p className="mt-1 font-sans text-xxs text-[#000000] opacity-85">{numberOfColleges} Colleges</p>
        </div>
      </div>
    </Link>
  );
};

export default StreamCard;
